import React from "react";
import ArrowIcon from "@public/images/icons/right-arrow.svg";
import PremiumReducedIcon from "@public/images/icons/premium-reduced.svg";

import {
  IconContainer,
  IdvPremiumContainer,
  PremiumReductionBannerWrapper,
  PremiumWrapper,
  PremiumText,
  PremiumAmount,
  PremiumReducedText,
  ReductionText
} from "./styles";
import DOMPurify from "dompurify";
import { getInrFormat } from "@utils/inrFormatter";

export const HighlightedHeading: React.FC<{ title: string }> = ({ title }) => {
  if (!title) return null;

  const formatTitle = (title: string): string => {
    return title
      .replace(
        /{bold}/g,
        '<span style="color: #0B753E; font-size: 14px; font-weight: 600; line-height: 16px">'
      )
      .replace(/{\/bold}/g, "</span>");
  };

  const sanitizedTitle = DOMPurify.sanitize(formatTitle(title));

  return <div dangerouslySetInnerHTML={{ __html: sanitizedTitle }} />;
};

const PremiumReductionBanner = (props) => {
  const { reduced_amount_text, options, oldPremium = 0, newPremium = 0 } = props;
  console.log("coco", props);
  const premDiff = Math.round(oldPremium - newPremium);
  const reducedText = `Your policy premium has reduced by {bold}₹${premDiff}{/bold}`;
  const RenderOptions = ({ options }) => {
    if (!options) return null;
    return options?.map((item, idx) => {
      return (
        <>
          <PremiumWrapper style={{ alignItems: "flex-start" }}>
            <PremiumText>{item?.text}</PremiumText>
            <PremiumAmount>{`₹${getInrFormat(item?.value)}`}</PremiumAmount>
          </PremiumWrapper>
          {idx === 0 && <ArrowIcon />}
        </>
      );
    });
  };

  return (
    <IdvPremiumContainer>
      <PremiumReducedText>
        <IconContainer>
          <PremiumReducedIcon />
        </IconContainer>
        <ReductionText>
          {" "}
          <HighlightedHeading title={reducedText} />
        </ReductionText>
      </PremiumReducedText>
      <PremiumReductionBannerWrapper>
        <RenderOptions options={options} />
      </PremiumReductionBannerWrapper>
    </IdvPremiumContainer>
  );
};

export default PremiumReductionBanner;
